import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

const CREATE_APP_VERISON = gql(`
  mutation CREATE_APP_VERISON($appId: ID!, $version: String, $message: String){
    appVersionCreate(appID: $appId, input: {
      message: $message,
      version: $version
    }) {
      id
      version
      message
    }
  }
`);
export const useCreateAppVersion = () => {
  return useMutation(CREATE_APP_VERISON);
};
